import { CheckCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { NotificationList } from '@/features/notifications';
import {
  useNotifications,
  useMarkAllNotificationsAsRead,
} from '@/hooks/use-notifications';

export function NotificationsPage() {
  const { data, isLoading, error } = useNotifications();
  const markAllAsRead = useMarkAllNotificationsAsRead();

  const notifications = data?.data || [];
  const hasUnread = notifications.some((n) => !n.isRead);

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold">Notifications</h1>
          <p className="text-muted-foreground">Stay updated with your tasks and mentions</p>
        </div>
        {hasUnread && (
          <Button
            variant="outline"
            size="sm"
            onClick={() => markAllAsRead.mutate()}
            disabled={markAllAsRead.isPending}
            className="gap-2"
          >
            <CheckCheck className="h-4 w-4" />
            Mark all as read
          </Button>
        )}
      </div>

      <Card>
        <CardContent className="p-0">
          <NotificationList
            notifications={notifications}
            isLoading={isLoading}
            error={error}
            showDelete
            maxHeight="max-h-[calc(100vh-240px)]"
          />
        </CardContent>
      </Card>
    </div>
  );
}
